<template>
    <div id="app">
        <router-view v-if="isLive" :pages="pages"></router-view>

        <v-countdown v-else></v-countdown>
    </div>
</template>

<style lang="scss">
    @import './static/scss/app.scss';
</style>

<script>
    // import Main from '@/app/layouts/Main';
    // import Scroller from '@/app/components/Scroller';
    import Countdown from '@/app/pages/Countdown';

    import Ontwikkeling from '@/app/pages/Ontwikkeling.vue';
    import Bedrijf from '@/app/pages/Bedrijf.vue';
    import Bereikt from '@/app/pages/Bereikt.vue';
    import Gewerkt from '@/app/pages/Gewerkt.vue';
    import Onderwijskwaliteit from '@/app/pages/Onderwijskwaliteit.vue';
    import Medewerker from '@/app/pages/Medewerker.vue';
    import Duurzaam from '@/app/pages/Duurzaam.vue';
    import Carriere from '@/app/pages/Carriere.vue';
    import Regio from '@/app/pages/Regio.vue';
    import Highlight from '@/app/pages/Highlight.vue';

    export default {
        name: 'App',

        components: {
            // 'scroller': Scroller,
            'v-countdown': Countdown
        },

        data()
        {
            return {
                now: new Date(),

                pages: [
                    Ontwikkeling,
                    Bedrijf,
                    Bereikt,
                    Gewerkt,
                    Onderwijskwaliteit,
                    Carriere,
                    Regio,
                    Medewerker,
                    Duurzaam,
                    Highlight
                ]
            };
        },

        computed: {
            liveDatum()
            {
                return this.$store.getters.liveDatum;
            },

            isLive()
            {
                return this.liveDatum < this.now;
            }
        },

        mounted()
        {
            window.addEventListener( 'resize', this.onResize );
            this.onResize();

            if( !this.isLive )
            {
                this.counterval = setInterval( () =>
                {
                    this.now = new Date();
                }, 1000 );
            }
        },

        methods: {
            onResize()
            {
                document.documentElement.style.setProperty( '--vh100', window.innerHeight + 'px' ); // fix for 100vh on iphones
            }
        }
    };
</script>
